export const state = () => ({
  userSettings: null,
});
